import { queryFormat } from '../../../helpers'

function requestAPI(queryString, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}withdrawal?${queryString}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionListWithdrawal(page, limit) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'LIST_WITHDRAWAL_BEGIN'
    })

    try {
      const queryString = await queryFormat({ 
        page: page, 
        limit: limit
      })
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(queryString, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_WITHDRAWAL_SUCCESS',
        page: result.data.page,
        pages: result.data.pages,
        payload: result.data.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'LIST_WITHDRAWAL_FAILURE',        
    error: error    
  })
}
